import React from 'react'
import Centered from 'shared/ui/Centered'
import Heading from 'shared/ui/Heading'
import { Hero, HeroPrimaryContent } from '../ui/Hero'
import CourseList from '../ui/CourseList'

export default function Learn() {
  return (
    <div>
      <Hero>
        <HeroPrimaryContent>
          <div className="spacing">
            <Heading className="text-color-blue">
              <span className="text-xlarge">Online Courses</span>
            </Heading>
            {/* <div className="text-large">
              Welcome to our online learning center. We have free and Paid Online Courses
            </div> */}
            <div className="text-large">Welcome to our online learning center.</div>
          </div>
        </HeroPrimaryContent>
      </Hero>

      <br />

      <Centered>
        <div className="spacing-large">
          <p>
            We're going to be offering a complete React and JavaScript learning experience right
            here from <a href="https://reacttraining.com/learn">ReactTraining.com/learn</a>. Until
            we get everything migrated over, our current online courses are still at Teachable:
          </p>
          <CourseList />
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <a href="https://courses.reacttraining.com" className="button">
              View All Online Courses
            </a>
          </div>
        </div>
      </Centered>
    </div>
  )
}
